import update from 'immutability-helper';
import * as AuthActionTypes from '../../auth/actions';

const createAnalyticsReducer = ({ types, mapActionToKey }) => {
	if (!Array.isArray(types) || types.length !== 3) {
		throw new Error('Expected types to be an array of three elements.');
	}
	if (!types.every(t => typeof t === 'string')) {
		throw new Error('Expected types to be strings.');
	}
	if (typeof mapActionToKey !== 'function') {
		throw new Error('Expected mapActionToKey to be a function.');
	}

	const [requestType, successType, failureType] = types;

	const initialState = {
		loading: false,
		filter: {},
		data: null
	};
	const updateAnalytics = (state = initialState, action) => {
		switch (action.type) {
			case requestType:
				const { ...filter } = action.payload;
				return update(state, {
					loading: { $set: true },
					filter: { $set: filter }
				});
			case successType:
				return update(state, {
					loading: { $set: false },
					data: { $set: action.response }
				});
			case failureType:
				return update(state, {
					loading: { $set: false }
				});
			default:
				return state;
		}
	};

	return (state = {}, action) => {
		// Update analytics by key
		switch (action.type) {
			case requestType:
			case successType:
			case failureType:
				const key = mapActionToKey(action);
				if (typeof key !== 'string') {
					throw new Error('Expected key to be a string.');
				}
				return update(state, {
					[key]: { $set: updateAnalytics(state[key], action) }
				});
			case AuthActionTypes.LOGOUT:
				return {};
			default:
				return state;
		}
	};
};

export default createAnalyticsReducer;
